var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_297_58",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0131836,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_297_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 17.2632C2.5875 17.2632 2.23438 17.1163 1.94063 16.8226C1.64688 16.5288 1.5 16.1757 1.5 15.7632V5.26318H3V15.7632H11.25V17.2632H3ZM6 14.2632C5.5875 14.2632 5.23438 14.1163 4.94063 13.8226C4.64688 13.5288 4.5 13.1757 4.5 12.7632V2.26318C4.5 1.85068 4.64688 1.49756 4.94063 1.20381C5.23438 0.910059 5.5875 0.763184 6 0.763184H11.25L15.75 5.26318V12.7632C15.75 13.1757 15.6031 13.5288 15.3094 13.8226C15.0156 14.1163 14.6625 14.2632 14.25 14.2632H6ZM10.5 6.01318H14.25L10.5 2.26318V6.01318Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.52fa30f00bb52a3d46524a89774c19df.svg";
export { ForwardRef as ReactComponent };